
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/quote/[...ticker]",
      function () {
        return require("private-next-pages/quote/[...ticker].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/quote/[...ticker]"])
      });
    }
  